import React from "react";
import { FormGroup, Label, Input, Row, Col } from "reactstrap";
import { Controller } from "react-hook-form";

export const Radio = ({
  name,
  disabled,
  control,
  required,
  className = "",
  options,
}) => (
  <Controller
    rules={{ required }}
    name={name}
    control={control}
    render={({ field: { onChange } }) => (
      <Row>
        {options?.map(opt => (
          <Col>
            <FormGroup check inline className={`${className}`}>
              <Label disabled={disabled} check>
                {opt.label}
              </Label>
              <Input
                name={name}
                type="radio"
                disabled={disabled}
                onChange={onChange}
                value={opt.value}
              />
            </FormGroup>
          </Col>
        ))}
      </Row>
    )}
  />
);
